<template>
  <section class="dashboard-sitters mb-64">
    <h3 class="text-h4">Sitters near {{ city }}</h3>
    <div class="flex gap-16 overflow-x-scroll lg:overflow-x-visible hide-scrollbar pb-24 pt-16 max-w-screen">
      <SmallSitterCard
        v-for="sitter in sitters"
        :key="sitter.node.sitter.id"
        custom-classes="min-w-[212px] flex-1"
        :photo-url="sitter.node.sitter.photoUrl"
        :name="sitter.node.sitter.name"
        :years-experience="sitter.node.yearsExperience"
        :min-rate="sitter.node.minRate"
        :max-rate="sitter.node.maxRate"
        :avg-rating="sitter.node.avgRating"
        :total-ratings="sitter.node.totalRatings"
        :sitter-id="sitter.node.sitter.id"
        :aria-label="`Explore Sitter ${sitter.node.sitter.name}`"
        target="_blank"
      />
    </div>
    <Button
      v-if="zipcode"
      class="p-0"
      variant="text"
      value="More sitters"
      :href="searchLinkUrl"
      :aria-label="`Sitters near ${city}`"
    />
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import Button from '@/components/button/Button.vue';
import SmallSitterCard from '@/components/sitter_card/SmallSitterCard.vue';

const props = defineProps<{
  sitters: any[];
  zipcode: string;
  city: string;
}>();

const searchLinkUrl = computed(() => `/availability/search?zipcode=${props.zipcode}&careType=babysitter`);
</script>
